import { Button, ButtonProps, Typography } from "@mui/material";
import { ReactElement } from "react";

export const BUTTON_WIDTH = "100px";

export function ActionButton(props: ButtonProps): ReactElement {
  const { sx, children, ...otherProps } = props;

  return (
    <Button
      variant="contained"
      sx={{ width: BUTTON_WIDTH, height: "27px", ...sx }}
      {...otherProps}
    >
      <Typography variant="h4Caps">{children}</Typography>
    </Button>
  );
}
